import Carousel from 'react-elastic-carousel';

import immutabilityHelper from 'immutability-helper';
import {
  defaultPlugin,
  FeaturedUsedPlugins,
  Plugin,
} from './FeaturedUsedPlugins';
import { FeaturedUsedPluginsItem } from './FeaturedUsedPluginsItem';
import { KTSVG } from '../../../../../../_start/helpers';

type FeaturedUsedPluginsListProps = {
  data: FeaturedUsedPlugins;
  update: (fieldsToUpdate: Partial<FeaturedUsedPlugins>) => void;
};

export const FeaturedUsedPluginsList = ({
  data,
  update,
}: FeaturedUsedPluginsListProps) => {
  const updatePlugin = (idx: number, plugin: Plugin) => {
    let plugins = [...data.plugins];
    plugins[idx] = plugin;

    const updatedData = { ...data, plugins };
    update(updatedData);
  };

  const addPlugin = () => {
    const plugins = immutabilityHelper(data.plugins, {
      $push: [defaultPlugin],
    });

    const updatedData = { ...data, plugins };
    update(updatedData);
  };

  const removePlugin = (itemIndex: number) => {
    let plugins = immutabilityHelper(data.plugins, {
      $splice: [[itemIndex, 1]],
    });

    const updatedData = { ...data, plugins };
    update(updatedData);
  };

  return (
    <div className="featured-used-plugins__carousel">
      <Carousel
        itemsToShow={4}
        isRTL={false}
        pagination={true}
        enableSwipe={false}
        enableMouseSwipe={false}
      >
        {data.plugins.map((plugin, idx) => (
          <FeaturedUsedPluginsItem
            key={idx}
            homePlugin={data}
            plugin={plugin}
            pluginIndex={idx}
            updatePlugin={updatePlugin}
            removePlugin={removePlugin}
          />
        ))}

        <div onClick={addPlugin} className="add-item">
          <div className="add-item__inner">
            <div className="m-auto d-flex flex-column">
              <KTSVG
                path="/media/icons/duotone/Interface/Plus-Square.svg"
                className="svg-icon-muted svg-icon-3hx text-center"
              />
              <span className="mt-4 text-gray-500">Add new item</span>
            </div>
          </div>
        </div>
      </Carousel>
    </div>
  );
};
